import React from 'react';
import { Skeleton, Box } from '@mui/material';

const SkeletonCard = () => {
  return (
    <div className='box-sizing-border-box flex flex-col items-start p-[30px_24px] w-[352px] tabletH:w-[422px] h-[500px] bg-white border-[1.6px] border-[#F9F7F4] rounded-[30px] self-stretch flex-none'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0px 0px 40px',
          width: '374px',
          height: '72px',
          alignSelf: 'stretch',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Skeleton
            variant='circular'
            width={28}
            height={28}
            sx={{ bgcolor: '#F9F7F4' }}
          />
          <Skeleton
            variant='rectangular'
            width={80}
            height={24}
            sx={{ bgcolor: '#F9F7F4', borderRadius: '6px' }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '0px 18px 40px',
          gap: '24px',
          width: '374px',
          height: '192px',
          alignSelf: 'stretch',
        }}
      >
        <Skeleton
          variant='rectangular'
          width={160}
          height={24}
          sx={{ bgcolor: '#F9F7F4', borderRadius: '6px' }}
        />
        <Skeleton
          variant='rectangular'
          width={338}
          height={40}
          sx={{ bgcolor: '#F9F7F4', borderRadius: '8px' }}
        />
        <Skeleton
          variant='rectangular'
          width={338}
          height={40}
          sx={{ bgcolor: '#F9F7F4', borderRadius: '8px' }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '40px 18px',
          gap: '24px',
          width: '374px',
          height: '152px',
          borderTop: '1px solid #F9F7F4',
          alignSelf: 'stretch',
        }}
      >
        <Skeleton
          variant='rectangular'
          width={338}
          height={24}
          sx={{ bgcolor: '#F9F7F4', borderRadius: '6px' }}
        />
        <Skeleton
          variant='rectangular'
          width={338}
          height={24}
          sx={{ bgcolor: '#F9F7F4', borderRadius: '6px' }}
        />
      </Box>
    </div>
  );
};

export default SkeletonCard;
